const SectionTitle = ({
  titleFirstPart,
  titleSecondPart,
  isBgDark,
}: {
  titleFirstPart: string;
  titleSecondPart: string;
  isBgDark?: boolean;
}) => {
  // rendering section title component here
  return (
    <h2
      className={`font-marcellus text-center text-3xl md:text-5xl lg:text-6xl font-semibold capitalize ${isBgDark ? 'text-legal-white' : 'text-legal-dark-blue'}`}
    >
      {titleFirstPart}{' '}
      <span className='font-playfair font-bold text-legal-brown italic border-b-2 md:border-b-4 border-legal-brown'>
        {titleSecondPart}
      </span>
    </h2>
  );
};

export default SectionTitle;
